import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Provide a safe fallback URL so the app can still render in preview/dev
// environments where env vars are not yet set. Actual DB calls will fail
// gracefully rather than crashing the whole app on init.
const safeUrl = supabaseUrl && supabaseUrl.startsWith('http')
  ? supabaseUrl
  : 'https://placeholder.supabase.co';

const safeKey = supabaseAnonKey || 'placeholder-key';

if (!supabaseUrl || !supabaseUrl.startsWith('http')) {
  console.warn(
    '[supabase] REACT_APP_SUPABASE_URL is not set or invalid. ' +
    'DB operations will fail. Set the correct value in .env before deploying.'
  );
}

const supabase = createClient(safeUrl, safeKey);

export default supabase;
